module.exports = __webpack_public_path__ + "static/media/NutriGuide_user_manual_HU_formatted.734e9df4.pdf";